import properUrlJoin from"proper-url-join";export var joinUrl=properUrlJoin;